import { render, staticRenderFns } from "./academic_font_management.vue?vue&type=template&id=c381436a&scoped=true&"
import script from "./academic_font_management.vue?vue&type=script&lang=js&"
export * from "./academic_font_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_font_management.vue?vue&type=style&index=0&id=c381436a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c381436a",
  null
  
)

export default component.exports